<div *ngIf="itineraries$ | async as itineraries">
  <mat-card id="card" class="mat-elevation-z8">
    <mat-nav-list style="padding-top:0;">
      <div *ngFor="let itinerary of itineraries; let last = last">
        <app-itinerary-list-item [itinerary]="itinerary" userRole="CUSTOMER"></app-itinerary-list-item>
        <mat-divider *ngIf="!last"></mat-divider>
      </div>
    </mat-nav-list>

    <app-empty-list-message *ngIf="itineraries.length == 0"
      message="Al momento non hai ancora nessun itinerario QuoVado." actionIcon="add"
      actionLabel="Inizia subito e richiedi il tuo itinerario su misura!"
      actionHref="https://www.quovado.com/it/inizia-ora?utm_source=mywanderoo">
    </app-empty-list-message>
  </mat-card>
</div>

<!--
<div class="container-intermedio">
  <h3 style="padding-top:10px; text-align:center">
    Lo sai che puoi portare i tuoi itinerari sempre con te grazie all'app my
    QuoVado per smartphone e tablet Android?
  </h3>

  <p style="text-align: center">
    <a
      href="https://go.quovado.com/app?utm_source=mywanderoo"
      mat-raised-button
      color="primary"
    >
      Installa App my QuoVado
    </a>
  </p>
</div>
-->